import React from 'react';

const MyBuyers = () => {
    return (
        <div>
            <h1>all buyers</h1>
        </div>
    );
};

export default MyBuyers;